<template>

  <div class="home-wrap">
    <img class="top-img" src="../../../assets/imgs/banner2.jpeg">
    <div class="contact-us-wrap">
      <div class="left-wrap">

        <div class="head-txt">
          研发平台/核心团队
        </div>
        <div @click="qiehuanTab(index)" :class="currTab == index ?'item-txt item-txt-select':'item-txt'"
             v-for="(txt, index) in menuList">
          {{ txt.text }}
        </div>
      </div>

      <div class="right-wrap">

        <div style="width: 100%;height: 1px;background-color: #333333"></div>

        <div class="text-title">
          当前位置：
          <div class="a-a" @click="goHome">首页</div>
          > 研发平台/核心团队 > {{ menuList[currTab].text }}
          <img class="c-us" src="../../../assets/imgs/serve-phone.png">
          <div class="c-line"></div>
        </div>

        <template v-if="currTab==0">
          <div class="content-w">

            <div class="yfpt-w">

              <img src="../../../assets/imgs/white-top.png">
              <div style="height: 40px"></div>

              <div id="pp" class="title">

              </div>
            </div>

            <div class="skjfsfds-wrap">
              <div class="img-wrap" v-for="(item,index) in $store.state.yfpt">
                <img :src="item.head_img">
                <div class="title">{{ item.title }}</div>
              </div>

            </div>


          </div>
        </template>
        <template v-if="currTab==1">

          <div class="team-item" v-for="(item ,index) in hxtd">
            <div class="yfpt-w">
              <img src="../../../assets/imgs/white-top.png">
              <div class="title">{{ item.title }}</div>
            </div>
            <div class="desc">
              <!--              浙江大学热能工程研究所教授、博导，浙江大学青山-->
              <!--              湖能源研究基地主任。浙江大学工程热物理博士，荷兰Delft技术大学访问学者。研究方向为煤和生物质燃烧与气化技术、CO2控制技术。主持负责了国家重点研发计划、国家973课题、国家自然科学基金、国家863项目、国际合作和企业合作项目等四十余项。获国家科技进步二等奖1项，省部科技进步一等奖3项，拥有发明专利40多项，在国内外学术刊物及学术会议上共发表论文100多篇,-->
              <!--              其中SCI、EI收录62篇，还合作完成了4本专著的编写工作。先后获得浙江省-->
              <!--              “151”人才工程第一层次、浙江省第七届青少年英才奖二等奖、浙江大学“亿利达优秀教师奖”、“第四届浙大优秀青年教师”、浙江大学优秀共产党员等称号。-->
            </div>
          </div>

          <!--          <div class="team-item">-->
          <!--            <div class="yfpt-w">-->
          <!--              <img src="../../../assets/imgs/white-top.png">-->
          <!--              <div class="title">王勤辉（特聘专家）</div>-->
          <!--            </div>-->
          <!--            <div class="desc">-->
          <!--              浙江大学热能工程研究所暨能源清洁利用国家重点实验室教授、博导，国家能源煤炭清洁转换利用技术研发（实验）中心副主任，中国颗粒学会常务理事,流态化专业委员会副主任，中国化工学会工程热化学专委会副主任，中国电机工程学会热电专业委员会委员，中国煤炭学会煤化工专业委员会委员，浙江省电力学会锅炉专业委员会委员。入选教育部新世纪人才计划，浙江省“新世纪151人才工程”计划第一层次。主要从事煤及生物质循环流化床热解、燃烧及气化技术、煤及生物质的热解气化燃烧分级转化多联产技术、煤及生物质利用过程的碳捕集技术、污染物控制以及气固多相流等方向的研究。主持负责国家自然科学基金、863、973、支撑计划以及国际合作等国家级项目或课题近20项以及40多项与国内外企业的合作科研项目，是国家十二五“863”项目首席专家，国家十三五重点研发计划项目负责人。已获省部级科技进步奖6项，发表论文200余篇，著作4本，国家发明专利20余项。-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="team-item">-->
          <!--            <div class="yfpt-w">-->
          <!--              <img src="../../../assets/imgs/white-top.png">-->
          <!--              <div class="title">王 涛（特聘专家）</div>-->
          <!--            </div>-->
          <!--            <div class="desc">-->
          <!--              浙江大学热能工程研究所暨能源清洁利用国家重点实验室教授、博导，长期从事二氧化碳捕集及利用领域的研究，近年来开发了用于空气CO2直接捕获的新型变湿再生气体分离技术、针对燃煤电厂烟气脱碳的有机蒸汽直接吹扫再生工艺等气体分离技术，以及CO2矿化养护混凝土等碳转化技术。其所开发的针对大气二氧化碳直接捕获的吸附技术，在2018年美国科学院、工程院联合发布的碳负排放报告中被列为该领域的两大主要技术方法之一。目前兼任中国环境科学会碳捕集利用与封存专委会委员，中国可持续发展研究会气候变化工作委员会委员，ICCU国际会议程序委员会主席，浙江省工程热物理学会秘书长，美国哥伦比亚大学高级客座研究员。近年来在JPCL、EST、Applied-->
          <!--              Energy等国际知名期刊发表SCI论文四十余篇，承担国家重点研发计划课题、国家自然科学基金、浙江省杰出青年基金等课题十余项。获高等学校科学技术进步奖一等奖1项。-->
          <!--            </div>-->
          <!--          </div>-->

          <div style="height: 30px"></div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
import $ from "jquery";

export default {
  name: "teamFragment",
  data: () => {

    return {
      currTab: 0,
      menuList: [{
        text: '研发平台',
      }, {
        text: '核心团队',
      }]
    }
  },
  computed: {
    yfpt() {
      let tmpCate = []
      let cateList = this.$store.state.yfpt
      for (let b = 0; b < cateList.length;) {
        let aa = cateList[b]
        let tmpItem = []
        tmpItem.push(aa)
        b++
        if (b < cateList.length) {
          let bb = cateList[b]
          tmpItem.push(bb)
          b++
        }
        if (b < cateList.length) {
          let bb = cateList[b]
          tmpItem.push(bb)
          b++
        }
        // if (b < cateList.length) {
        //   let bb = cateList[b]
        //   tmpItem.push(bb)
        //   b++
        // }
        tmpCate.push(tmpItem)
      }
      return tmpCate
    },
    hxtd() {
      return this.$store.state.tpzj
    }
  },
  mounted() {
    let iii = setInterval(() => {
      clearInterval(iii)
      $("#pp").empty()
      $("#pp").append(this.$store.state.yfptBt[0].detail);
    }, 10)

  },
  watch: {
    currTab(vv) {

      if (vv == 0) {
        let iii = setInterval(() => {
          clearInterval(iii)
          $("#pp").empty()
          $("#pp").append(this.$store.state.yfptBt[0].detail);
        }, 10)
      } else {
        let iii = setInterval(() => {
          clearInterval(iii)
          let tpzj = this.$store.state.tpzj
          console.log((tpzj))

          for (let i = 0; i < tpzj.length; i++) {
            let ee = $(".desc:eq(" + i + ")")
            ee.empty()
            ee.append(tpzj[i].detail)
          }

        }, 10)
      }

    }
  },
  methods: {
    goHome() {
      this.$router.replace('/home')
    },
    qiehuanTab(i) {
      this.currTab = i
    }
  }
}
</script>

<style lang="less" scoped>
.home-wrap {

  display: flex;
  width: 100%;
  min-width: 1400px;
  align-items: center;
  background-color: white;
  flex-direction: column;

  .top-img {
    width: 100%;
    min-width: 100%;
  }

}

.contact-us-wrap {
  width: min-content;
  min-height: 100%;
  padding-top: 10px;
  min-width: 100%;
  display: flex;
  background-color: white;
  justify-content: center;

  .left-wrap {
    width: 230px;
    display: flex;
    flex-direction: column;

    .head-txt {
      background-color: #063979;
      width: 100%;
      height: 60px;
      line-height: 60px;
      color: white;
      font-size: 18px;
      padding-left: 20px;
    }

    .item-txt {
      width: 100%;
      background-color: #DEDFE0;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      font-size: 16px;
      color: #666666;
      margin-top: 2px;
    }

    .item-txt-select {
      color: #143772;
      border-bottom: 1px #143772 solid;
    }
  }

  .right-wrap {
    display: flex;
    flex-direction: column;
    width: 970px;
    margin-left: 10px;

    .text-title {
      color: #666666;
      font-size: 16px;
      display: flex;
      height: 34px;
      align-items: center;
      position: relative;

      .c-us {
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .a-a {
        margin-left: 5px;
        margin-right: 5px;
        font-size: 16px;
        color: #666666;
      }

      .a-a:hover {
        text-decoration: underline;
        color: #22B5A8;
      }

      .c-line {
        background-color: #333333;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 20px;
      }
    }

    .content-w {
      margin-top: 30px;
      width: 100%;
      margin-bottom: 30px;

      .yfpt-w {
        width: 100%;
        background-image: linear-gradient(to right, #1565A8, #84B2EF);
        position: relative;
        display: flex;
        flex-direction: column;

        img {
          top: 20px;
          left: 30px;
          position: absolute;
        }

        .title {
          margin-left: 45px;
          color: white;
          margin-right: 20px;
          margin-bottom: 20px;
          font-size: 18px;
        }
      }

      .skjfsfds-wrap {
        width: 1004px;
        display: flex;
        margin-left: -12px;
        flex-wrap: wrap;

        .img-wrap {
          display: flex;
          margin-top: 10px;
          padding: 5px;
          width: 224px;
          margin-left: 12px;
          margin-right: 12px;
          flex-direction: column;
          background-color: #CDE5FE;

          img {
            width: 100%;
            height: 160px;
          }

          .title {
            font-size: 14px;
            width: 100%;
            color: #333333;
            margin-left: 5px;
            margin-right: 5px;
            height: 30px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 30px;
          }
        }
      }


    }

    .team-item {
      width: 100%;
      background-color: #F3F4F5;
      display: flex;
      flex-direction: column;
      margin-top: 10px;

      .yfpt-w {
        width: 100%;
        background-image: linear-gradient(to right, #1565A8, #84B2EF);
        height: 100px;
        position: relative;

        img {
          top: 20px;
          left: 30px;
          position: absolute;
        }

        .title {
          top: 40px;
          left: 45px;
          color: white;
          font-size: 18px;
          position: absolute;
        }
      }

      .desc {
        margin: 16px;
        color: #333333;
        font-size: 16px;
      }
    }
  }
}
</style>
